import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import styles from "./CountButtonCell.module.scss";

interface Props {
    count: number;
    ariaLabel: string;
    onClick: (event: React.MouseEvent) => void;
}

export const CountButtonCell: React.FC<Props> = ({
    count,
    ariaLabel,
    onClick,
}) => (
    <ViewTableCell captureClicks>
        <Button
            variant="secondary"
            size="sm"
            className={styles.countButton}
            onClick={onClick}
            disabled={count === 0}
            aria-label={ariaLabel}
        >
            {count}
        </Button>
    </ViewTableCell>
);
